import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Badge, IconButton } from '@mui/material';
import { TFunction } from 'i18next';
import React from 'react';

type NotificationsBellProps = {
  t: TFunction;
  unreadCount: number;
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
  classes: {
    iconButton: string;
    utilityIcon: string;
    badge: string;
  };
};

export function NotificationsBell({
  t, unreadCount, onClick, classes,
}: NotificationsBellProps) {
  const count = Math.max(0, Number(unreadCount) || 0);

  return (
    <IconButton
      className={classes.iconButton}
      aria-label={count > 0 ? t('notifications:bell-label-unread', { count }) : t('notifications:bell-label')}
      title={t('notifications:bell-label')}
      onClick={onClick}
      size="large"
    >
      <Badge
        overlap="rectangular"
        max={99}
        badgeContent={count}
        classes={{ badge: classes.badge }}
      >
        <FontAwesomeIcon icon="bell" className={classes.utilityIcon} />
      </Badge>
    </IconButton>
  );
}
